import React from 'react';
import styled from 'styled-components';

export const Sect = styled.section`
display: flex;
justify-content: space-between;
margin-left: 20em;
margin-right: 20em;
`

export const Form = styled.form`
background-color: #202027;
display: flex;
flex-direction: column;
gap: 1em;
width: 20em;
padding: 3em;
border-radius: 15px;
margin-top: 4em;
`

export const Label = styled.label`
background-color: #202027;
display: flex;
flex-direction: column;
`
export const Titl = styled.h1`
display: flex;
align-self: center;
font-weight: 600;
font-size: 40px;
`
export const Bold = styled.strong`
color: #2796ff;
font-weight: 600;
`
export const LargeButton = styled.button`
    font-size: 1em;
    border: none;
    border-radius: 5px;
    background-color: #1762a7;
    width: 20em;
    height: 2.5em;
    cursor: pointer;
`

export const Input = styled.input`
border-radius: 5px;
border: 2px solid #2E3852;
`
